import { useSelector } from 'react-redux';
import { GAClickProduct, getRatingText } from 'utils';
import { TConfigurator } from 'containers/configurators-listing/types';
import { selectConfiguratorRating } from '../../../../selectors';

type THookParams = {
	pageUrl: string;
	configurator: TConfigurator;
	position: number;
};

export const useConfiguratorRating = ({ pageUrl, configurator, position }: THookParams) => {
	const { name, price, id } = configurator;
	const { avgRating, totalReviews } = useSelector(selectConfiguratorRating(id));
	const ratingText =
		totalReviews === 0 ? 'Нет отзывов' : `${totalReviews} ${getRatingText(totalReviews)}`;
	const reviewsUrl = `${pageUrl}/#reviews`;

	const ratingClickHandler = (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		e.stopPropagation();

		window.location.assign(reviewsUrl);

		GAClickProduct({
			elementBlock: 'serviceList',
			elementName: 'productRatingLink',
			elementText: String(totalReviews),
			productName: name,
			productId: String(id),
			productPrice: String(price),
			productPosition: String(position),
		});
	};

	return {
		avgRating,
		ratingText,
		ratingClickHandler,
	};
};
